module.exports = __webpack_public_path__ + "img/correct_btn.5ca2de4e.png";